/* Tartan Plaid 2026-10-31: collection pages (snippets/tp-coll-grid.liquid + assets/tp-collection.css).
   - card photos: dots follow the swipe, arrows on hover, the next photos load on first touch / hover
   - clan headings: one is dropped when "Load more" (or "Load previous") continues the same clan
   - heading: "150 products · clans starting with A" under the title
   - A-Z row on phones: one swipeable row with arrow buttons
   - toolbar: "Showing 24 of 150 products" (tablet / desktop), "Sort by" label, short sort name on phones (A-Z)
   Kalles replaces the product grid after filtering, sorting and Load more; a MutationObserver re-runs the setup. */
(function () {
  'use strict';
  var SEC = document.querySelector('.t4s-collection-page');
  if (!SEC || window.__tpcInit) return;
  window.__tpcInit = true;

  var ARROW = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
  var PREV = 'm15 18-6-6 6-6', NEXT = 'm9 18 6-6-6-6';
  var IRISH = /irish/i.test(location.pathname + ' ' + document.title);
  var grid = function () { return SEC.querySelector('.tp-grid'); };
  var setText = function (el, t) { if (el && el.textContent !== t) el.textContent = t; };

  /* ---------- card photos ---------- */
  function initMedia(m) {
    if (m.__tpc) return;
    m.__tpc = 1;
    var tr = m.querySelector('.tpc-track'), dots = m.querySelectorAll('.tpc-dots i');
    var pv = m.querySelector('.tpc-prev'), nx = m.querySelector('.tpc-next');
    if (!tr || dots.length < 2) return;
    var cur = 0;
    var warm = function () {
      Array.prototype.forEach.call(m.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; });
    };
    var upd = function () {
      var k = Math.max(0, Math.min(dots.length - 1, Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth))));
      if (k === cur) return;
      cur = k;
      Array.prototype.forEach.call(dots, function (d, j) { d.classList.toggle('on', j === k); });
      if (pv) pv.disabled = k <= 0;
      if (nx) nx.disabled = k >= dots.length - 1;
    };
    tr.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    m.addEventListener('pointerenter', warm, { once: true });
    m.addEventListener('touchstart', warm, { once: true, passive: true });
    m.addEventListener('focusin', warm, { once: true });
    var go = function (dir) {
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        warm();
        tr.scrollBy({ left: dir * tr.clientWidth, behavior: 'smooth' });
      };
    };
    if (pv) pv.addEventListener('click', go(-1));
    if (nx) nx.addEventListener('click', go(1));
  }

  /* ---------- clan headings after Load more / Load previous ---------- */
  function fixGroups() {
    var g = grid();
    if (!g) return;
    var last = '', seen = {};
    Array.prototype.slice.call(g.children).forEach(function (el) {
      if (el.classList.contains('tpc-group')) {
        var k = el.getAttribute('data-clan');
        if (k === last) { el.parentNode.removeChild(el); return; }
        // the same clan again after another one (A-Z by title: "MacDonald Dress", "MacDonald of Sleat", "MacDonald Weathered"): no count the second time
        if (seen[k] && !el.classList.contains('tpc-again')) el.classList.add('tpc-again');
        seen[k] = 1;
      } else if (el.classList.contains('tpc-card')) {
        var c = el.getAttribute('data-clan');
        if (c) last = c;
      }
    });
  }

  /* ---------- counts ---------- */
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
  function counts() {
    var g = grid(), hdr = SEC.querySelector('.t4s-collection-header');
    if (!g || !hdr) return;
    var total = +g.getAttribute('data-tp-total') || 0, lo = 0, hi = 0;
    Array.prototype.forEach.call(g.querySelectorAll('.tpc-card[data-i]'), function (c) {
      var i = +c.getAttribute('data-i') || 0;
      if (!i) return;
      if (!lo || i < lo) lo = i;
      if (i > hi) hi = i;
    });
    hi = Math.min(hi, total);
    var s = hdr.querySelector('.tpc-showing');
    if (!s) {
      s = document.createElement('span');
      s.className = 'tpc-showing';
      hdr.insertBefore(s, hdr.firstChild);
    }
    // page 2+ opened directly (a refresh after Load more, a numbered page): "Showing 25–48 of 150 products"
    setText(s, hi ? 'Showing ' + (lo > 1 ? lo + '–' : '') + hi + ' of ' + plural(total, 'product') : '');
  }
  function headCount() {
    var h = document.querySelector('.page_section_heading h1.title-head') || document.querySelector('h1.title-head');
    var g = grid();
    if (!h || !g || document.querySelector('.tpc-hcount')) return;
    var all = +g.getAttribute('data-tp-all') || 0;
    if (!all) return;
    var t = plural(all, 'product');
    var act = document.querySelector('.cp-alpha-nav .alpha-btn.is-active');
    if (act) {
      var l = act.textContent.trim();
      if (l.length > 1) l = l.split('').join(', ').replace(/, ([^,]+)$/, ' or $1');
      t += ' · ' + (IRISH ? 'names' : 'clans') + ' starting with ' + l;
    }
    var p = document.createElement('p');
    p.className = 'tpc-hcount';
    p.textContent = t;
    h.insertAdjacentElement('afterend', p);
  }

  /* ---------- A-Z row (phones) ---------- */
  function azRow() {
    var nav = document.querySelector('.cp-alpha-nav');
    if (!nav || nav.classList.contains('tpc-az')) return;
    var wrap = nav.querySelector('.alpha-wrap'), row = nav.querySelector('.alpha-grid');
    if (!wrap || !row || !row.querySelector('.alpha-btn')) return;
    nav.classList.add('tpc-az');
    var lab = document.createElement('span');
    lab.className = 'tpc-azl';
    lab.textContent = (IRISH ? 'Family names' : 'Clans') + ' by first letter';
    nav.insertBefore(lab, wrap);
    var mk = function (cls, label, d) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tpc-azarr ' + cls;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<span>' + ARROW(d) + '</span>';
      wrap.appendChild(b);
      return b;
    };
    var pv = mk('prev', 'Show earlier letters', PREV), nx = mk('next', 'Show more letters', NEXT);
    var upd = function () {
      var scrollable = row.scrollWidth > row.clientWidth + 4;
      pv.hidden = !scrollable || row.scrollLeft < 4;
      nx.hidden = !scrollable || row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    };
    row.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    pv.addEventListener('click', function () { row.scrollBy({ left: -(row.clientWidth - 90), behavior: 'smooth' }); });
    nx.addEventListener('click', function () { row.scrollBy({ left: row.clientWidth - 90, behavior: 'smooth' }); });
    var cur = row.querySelector('.alpha-btn.is-active');
    if (cur && cur.offsetLeft + cur.offsetWidth > row.clientWidth - 60) row.scrollLeft = cur.offsetLeft - row.clientWidth / 2 + cur.offsetWidth / 2;
    upd();
    window.addEventListener('resize', upd);
  }

  /* ---------- toolbar: sort labels ---------- */
  var SHORT = { 'title-ascending': 'A–Z', 'title-descending': 'Z–A', 'price-ascending': 'Price ↑', 'price-descending': 'Price ↓', 'best-selling': 'Best selling', 'created-descending': 'Newest', 'created-ascending': 'Oldest', 'manual': 'Featured', 'most-relevant': 'Relevance' };
  function sortLabel() {
    var dd = SEC.querySelector('.t4s-dropdown__sortby');
    if (!dd) return;
    var btn = dd.querySelector('[data-dropdown-open]'), sel = dd.querySelector('[data-sortby-item].is--selected');
    if (!btn) return;
    var sm = btn.querySelector('.tpc-sortv');
    if (!sm) {
      sm = document.createElement('small');
      sm.className = 'tpc-sortv';
      var mob = btn.querySelector('[data-not-change-txt]');
      if (mob) mob.insertAdjacentElement('afterend', sm); else btn.appendChild(sm);
    }
    setText(sm, sel ? (SHORT[sel.getAttribute('data-value')] || '') : '');
    if (!SEC.querySelector('.tpc-sortl')) {
      var l = document.createElement('span');
      l.className = 'tpc-sortl';
      l.textContent = 'Sort by';
      dd.parentNode.insertBefore(l, dd);
    }
  }

  /* ---------- run + re-run after Kalles updates the grid ---------- */
  var queued = false;
  function refresh() {
    queued = false;
    Array.prototype.forEach.call(SEC.querySelectorAll('.tpc-media'), initMedia);
    fixGroups();
    counts();
    sortLabel();
  }
  function start() {
    azRow();
    headCount();
    refresh();
    new MutationObserver(function () {
      if (!queued) { queued = true; requestAnimationFrame(refresh); }
    }).observe(SEC, { childList: true, subtree: true });
    SEC.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-sortby-item]')) setTimeout(sortLabel, 50);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
